<template>
<van-popup v-model="show" class="service-popup"  @click-overlay="closePopup">
    <div class="m-mask" @click="closePopup"></div>
    <div class="serviceCode" :style="`width: ${pop.width}`">
        <div class="codeBox">
            <img class="code" :src="pop.url" alt="" :style="pop.size?'width:'+pop.size[0]+'rem;height:'+pop.size[1]+'rem':''">
        </div>
        <div class="btn" v-if="pop.isSave">
            <!-- <van-button type="info" @click="saveImage">保存图片</van-button> -->
            <span>扫码添加企业专属客服</span>
        </div>
        <p class="p_text" v-for="(obj, index) in pop.tip" :key="index">{{obj.title}}<span>{{obj.text}}</span></p>
        <slot></slot>
    </div>
    <div class="closeBox">
        <div class="close icon-popup-close" @click="closePopup"></div>
    </div>
</van-popup>
</template>
<script>
import {downloadImage} from 'common/js/tools'
export default {
    name: 'successPayTips',
    data() {
        return {
            show: false,
            img: ''
        }
    },
    props: ['pop'],
    methods: {
        saveImage() {
            downloadImage(this.pop.url, '12')
        },
        open() {
            this.show = true
        },
        closePopup() {
            this.show = false
        }
    },
    watch: {
        'src': {
            handler() {
                this.img = this.src
            }
        }
    }
}
</script>
<style lang="scss">
.service-popup {
    border-radius: 0.16rem;
    width: 100%;
    height: 100%;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .m-mask{
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        z-index: -1;
    }
    .serviceCode {
        width: 5rem;
        border-radius: 0.16rem;
        text-align: center;
        padding: 0.32rem;
        box-sizing: border-box;
        background: #fff;
        .p_text {
            // margin-top: 0.16rem;
            font-size: 0.28rem;
            line-height: 0.4rem;
            color: #333333;
            text-align: left;
            span {
                color: #2E7FFF;
            }
        }
        .codeBox {
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            .code {
                width: 3rem;
                height: 3rem;
                margin-bottom: 0.2rem;
            }
        }
        .btn{
            // margin-top: 0.28rem;
            display: flex;
            justify-content: center;
            .van-button--info{
                width: 3.48rem;
                height: 0.6rem;
                line-height: 1;
                border-radius: 0.3rem;
            }
            span {
                margin-bottom: 0.2rem;
            }
        }
    }
    .closeBox {
        margin-top: 0.4rem;
        width: 0.6rem;
        height: 0.6rem;
        .close {
            width: 0.6rem;
            height: 0.6rem;
        }
    }
}
</style>
